/* eslint-disable @typescript-eslint/no-explicit-any */
import { debounce } from 'lodash';

export const onDelay = (fn: any, wait = 1000) => debounce(fn, wait);
